import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoSimulationsGetRes } from "./abst/DtoSimulationsGetRes";
import { EntitySimulationImple } from "../entity/EntitySimulationImple";

export class DtoSimulationsGetResImple extends DtoSimulationsGetRes {
  public itemsImple: EntitySimulationImple[] = [];
  public pager = new DtoApiPager();
}
